var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 47.5H55M47.5 40V55M15 52.5V47.5C15 44.8478 16.0536 42.3043 17.9289 40.4289C19.8043 38.5536 22.3478 37.5 25 37.5H35M20 17.5C20 20.1522 21.0536 22.6957 22.9289 24.5711C24.8043 26.4464 27.3478 27.5 30 27.5C32.6522 27.5 35.1957 26.4464 37.0711 24.5711C38.9464 22.6957 40 20.1522 40 17.5C40 14.8478 38.9464 12.3043 37.0711 10.4289C35.1957 8.55357 32.6522 7.5 30 7.5C27.3478 7.5 24.8043 8.55357 22.9289 10.4289C21.0536 12.3043 20 14.8478 20 17.5Z",
    stroke: "#DE1F4C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user-plus.6fe32e97c1975bdc510755d437942aba.svg";
export { ForwardRef as ReactComponent };